
import {supportCORS} from './core/browser'

function brand() {
    return location.hostname.split('.')[0].replace(/[_-]/g, '')
}

const config = {
    env: process.env.NODE_ENV || 'development',
    https: process.env.HTTPS == 'true',
    api: {
        url: process.env.WEBPACK && (supportCORS() && process.env.API_URL || '/api/v1') || process.env.API_URL,
        event: {
            url: process.env.WEBPACK && (supportCORS() && process.env.API_EVENT_URL || '/api/vEvent') || process.env.API_EVENT_URL
        },
        front: {
            url: '/api/vFront'
        }
    },
    socket: {
        front: {
            url: '/socket/vFront',
            protocol: 'v1'
        }
    },
    audit: {
        url: process.env.AUDIT_URL || 'http://localhost:9000',
        api: {
            url: process.env.WEBPACK && (supportCORS() && process.env.AUDIT_API_URL || '/audit/api') || process.env.AUDIT_API_URL
        }
    },
    ticketHelper: {
        api: {
            url: process.env.WEBPACK && (supportCORS() && process.env.TICKETHELPER_API_URL || '/tickethelper/api/v1') || process.env.TICKETHELPER_API_URL
        }
    },
    administrativeDivision: {
        api: {
            url: process.env.WEBPACK && (supportCORS() && (process.env.ADMINISTRATIVEDIVISION_API_URL || 'unset') || '/administrativedivision') || process.env.ADMINISTRATIVEDIVISION_API_URL
        }
    },
    google: {
    	apiKey: process.env.GOOGLE_API_KEY
    },
    intercom: {
        appId: process.env.INTERCOM_APP_ID
    },
    resource: process.env.WEBPACK && process.env.RESOURCE[brand()] || {},
    data: {
        providerCoverageCriteriaActivityUids: process.env.WEBPACK && process.env.DATA['providercoveragecriteriaactivityuids'] || ['dqsmlkdmsqlkdmqslkdmqslk']
    },
    feature: {
        audit: process.env.FEATURE_AUDIT == 'true'
    },
    whiteMark : {
        titlePrefix : process.env.WHITE_MARK_TITLE_PREFIX,
        bottomLogo : process.env.WHITE_MARK_BOTTOMLOGO,
        bottomLogoLink : process.env.WHITE_MARK_BOTTOMLOGO_LINK,
        cguLink : process.env.WHITE_MARK_CGU_LINK
    }
}

export default config


// WEBPACK FOOTER //
// ./lib/config.js